angular.module('jv.search.serializer.service', [])
.service('jvSearchSerializer', [
    function() {
        var lzstring = require('../../../lib/lz-string.min.js');
        this.serialize = function(obj) {
            var nonEmptyValues = {};
            Object.keys(obj).forEach(function(key) {
                if (obj[key] != null) {
                    nonEmptyValues[key] = obj[key];
                }
            });
            return lzstring.compressToEncodedURIComponent(JSON.stringify(nonEmptyValues));
        };
        this.deserialize = function(str) {
            return JSON.parse(lzstring.decompressFromEncodedURIComponent(str));
        };
    }
]);